import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.jsx';
import { useTenant, useBrand } from '../tenant/TenantProvider.jsx';
import { isMarketingSite } from '../lib/subdomain.js';
import { readLastRoute } from '../lib/lastRoute.js';
import Footer from '../components/Footer.jsx';
import MarketingLanding from './MarketingLanding.jsx';

export default function Landing() {
  const { user, claims, loading } = useAuth();
  const { gym } = useTenant();
  const brand = useBrand();
  const nav = useNavigate();
  const role = claims.role || 'member';
  const roleHome = role === 'platform-admin' ? '/platform'
    : role === 'owner' ? '/admin'
    : role === 'trainer' ? '/trainer'
    : '/app';
  // Return to wherever they last were (RequireRole still guards access), so a
  // platform admin who was in the member app doesn't get bounced to /platform
  // every launch. Falls back to the role's default shell.
  const dest = readLastRoute() || roleHome;

  useEffect(() => {
    if (!loading && user) nav(dest, { replace: true });
  }, [loading, user, dest, nav]);

  if (loading) return <div className="centered">Loading…</div>;
  if (user) return <div className="centered">Redirecting…</div>;

  // Root domain (mytrainforge.com) → marketing site
  if (isMarketingSite()) return <MarketingLanding />;

  // Gym subdomain or other → branded gym landing
  const isBranded = !!gym?.name && gym.name !== 'TrainForge';
  const logoSrc = brand.logoUrl || '/trainforge-logo.svg';
  const displayName = isBranded ? gym.name.toUpperCase() : 'TRAINFORGE';

  return (
    <div className="centered" style={{ flexDirection: 'column', gap: '20px', padding: 24, minHeight: '100vh' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
        <img src={logoSrc} alt={displayName} width={140} height={140} style={{ filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.6))', borderRadius: 16, objectFit: 'cover' }} />
        <div className="wordmark" style={{ fontSize: '2.5rem' }}>{displayName}</div>
        <div className="tagline">{brand.tagline || 'AI-Powered Training'}</div>
        <Link to="/login">
          <button className="primary" style={{ minWidth: 200 }}>Sign in</button>
        </Link>
      </div>
      <Footer />
    </div>
  );
}
